<template>
    <div>
        <div class="sau-bx bx-pad">
            <div class="row">
                <div class="col-lg-4">
                    <h5>Knowledge Base</h5>
                    <p class="sau-font sm">Find the right answer quickly and easily in the <a href="https://help.serversaustralia.com.au" target="_blank" rel="noreferrer noopener">Servers Australia Knowledge Base</a>.</p>
                </div>
                <div class="col-lg-4">
                    <h5>Get Support</h5>
                    <p class="sau-font sm">We've simplified our support to make your experience even better. <a href="/support/cases">Open a case</a> with our specialist 24/7 Support Team.</p>
                </div>
                <div class="col-lg-4">
                    <h5>Blog</h5>
                    <p class="sau-font sm">Catch up on the latest hosting news and find out what we've been up to on the <a href="https://www.serversaustralia.com.au/articles/" target="_blank" rel="noreferrer noopener">Servers Australia Blog</a>.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
